import LoadingScreen from "../lib/loading-screen";
import Popup from "../lib/popup";

var DOC = document;

var CORE = {

	className: 'brtn-newsletter__form',

	elements: null,

	onDone: function (r) {

		LoadingScreen.hide();

		Popup.setHeader(r.title, true);
		Popup.setBody(r.content);
		Popup.show();

	},

	onSubmit: function (e) {
		var Form = new FormData(this);

		e.preventDefault();

		LoadingScreen.show();

		Form.append('action', 'subscribe');

		$.ajax({
			method: 'POST',
			url: '/ajax/newsletter.php',
			dataType: 'json',
			processData: false,
			contentType: false,
			data: Form
		}).done(CORE.onDone);

	},

	construct: function () {
		var els = DOC.getElementsByClassName(CORE.className);
		var i = 0;

		if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
			return false;
		}
		CORE.elements = [];

		for (i; i < els.length; i++){
			CORE.elements[CORE.elements.length] = els[i];
			els[i].addEventListener('submit', CORE.onSubmit);
		}

	}

};

export default CORE.construct;